import { useQuery } from 'react-query';
import { DashboardService, FixedPricePrefixType, getCo2Data, getCo2Options } from '~/api/services/dashboard';
import { onError } from '~/utils/helpers';

const getDashboardNextTrading = (prefix: FixedPricePrefixType) => useQuery(
  `dashboard-next-trading-${prefix}`,
  DashboardService(prefix).getNextTradingSlot,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDashboardPreviousTrading = (prefix: FixedPricePrefixType) => useQuery(
  `dashboard-previous-trading-${prefix}`,
  DashboardService(prefix).getPreviousTradingSlot,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDashboardSettings = (prefix: FixedPricePrefixType) => useQuery(
  `dashboard-settings-${prefix}`,
  DashboardService(prefix).getSettings,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDashboardChartData = (prefix: FixedPricePrefixType) => useQuery(
  `dashboard-chart-data-${prefix}`,
  DashboardService(prefix).getChartTradingData,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDashboardCo2Data = (farmerId) => useQuery(
  'dashboard-co2-data',
  () => getCo2Data({ farmerId }),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDashboardCo2Options = () => useQuery(
  'dashboard-co2-options-data',
  getCo2Options,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const DashboardQuery = {
  getDashboardChartData,
  getDashboardNextTrading,
  getDashboardPreviousTrading,
  getDashboardSettings,
  getDashboardCo2Data,
  getDashboardCo2Options
}